<template>
  <section>
    <div class="fileBoxStep1">
      <div class="upload">
        <video-upload
          ref="upload1"
          v-model="list"
          class="videoUpload"
          :action="action"
          :limit="1"
          :is-delete="state == 0"
          @loadUrl="loadUrl"
          @deleteVideo="deleteVideo"
        />
        <!-- <com-upload
            :action="videoAction"
            v-model="videoList"
            type="video"
            :limit="1"
            :width="312"
            :height="298"
            @loadUrl="loadUrl"
            @deleteVideo="deleteVideo"
          /> -->
      </div>
    </div>
  </section>
</template>

<script>
import videoUpload from '@/components/system/upload/videoUpload.vue'
import comUpload from '@/components/comUpload'
export default {
  name: 'ComStep1',
  components: {
    videoUpload,
    comUpload
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    action: {
      type: String,
      default: ''
    },
    state: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data2: this.data1
    }
  },
  computed: {
    list: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {
    loadUrl(v) {
      this.$emit('add', v)
    },
    deleteVideo(v) {
      this.$emit('del', v)
    }
  }
}
</script>
<style lang="scss" scoped>
.upload{
  min-height: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload /deep/ .uploadBox
  {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
</style>
